import React from 'react';
import Modal from '../Modal/Modal';
import arrowBtn from '../../assets/images/Arrow-up-right-black.svg';

// title, date, course, description, image

const EducationItem = (props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="education__text-container">
      <div className="education__text-container-names">
        <h3>{props.title}</h3>
        <h3>{props.date}</h3>
      </div>
      <div className="education__text-container-descriptions">
        <p>{props.course}</p>
        <span>{props.description}</span>
      </div>
      <button onClick={openModal}>
        {props.document}
        <img src={arrowBtn} alt="arrow" />
      </button>
      <div
        className={
          props.direction === 'ver' ? 'education__image education__image_ver' : 'education__image'
        }>
        <img src={props.image} alt="diploma" />
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal} imageUrl={props.image} />
    </div>
  );
};

export default EducationItem;
